(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9772],{

/***/ 45671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Status; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4549);
/* harmony import */ var _status_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37316);
/* harmony import */ var _status_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_status_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Status = (props)=>{
    const statuses = {
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.DRAFT */ .cp.DRAFT]: {
            label: "Черновик",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().yellow_outline)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.NEW */ .cp.NEW]: {
            label: "Ждет допуска к ФП",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().yellow_outline)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.ADMITTED */ .cp.ADMITTED]: {
            label: "Допущена к ФП",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().yellow)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.APPROVED */ .cp.APPROVED]: {
            label: "К выплате",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().green)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.CLOSED */ .cp.CLOSED]: {
            label: "Закрыта",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gray)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.DECLINED */ .cp.DECLINED]: {
            label: "Отклонена",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gray)
        },
        [shared_api__WEBPACK_IMPORTED_MODULE_2__/* .FundingRequestStatus.CANCELED */ .cp.CANCELED]: {
            label: "Отменена",
            color: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gray)
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: props.status && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().status), props.className, props.row && (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[props.row], props.type && (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[props.type]),
            style: props.style,
            id: props.htmlId,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().circle), statuses === null || statuses === void 0 ? void 0 : statuses[props.status].color)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_status_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
                    children: statuses === null || statuses === void 0 ? void 0 : statuses[props.status].label
                })
            ]
        })
    });
};
Status.defaultProps = {
    type: "default",
    row: "row"
};


/***/ }),

/***/ 18939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FundingRequestList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/modules/finances/_shared/status/status.tsx
var status_status = __webpack_require__(45671);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/lib/format-date.ts
var format_date = __webpack_require__(68984);
// EXTERNAL MODULE: ./src/shared/lib/format-number.ts
var format_number = __webpack_require__(9195);
// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
// EXTERNAL MODULE: ./src/modules/finances/entities/funding-request/funding-request-entity.module.scss
var funding_request_entity_module = __webpack_require__(1763);
var funding_request_entity_module_default = /*#__PURE__*/__webpack_require__.n(funding_request_entity_module);
;// CONCATENATED MODULE: ./src/modules/finances/entities/funding-request/funding-request-entity.tsx









const FundingRequestEntity = (props)=>{
    var _props_data_payAt, _props_data_fund;
    // funding request page preloading
    init/* api.fundingRequest.useFundingRequestGet */.h.fundingRequest.useFundingRequestGet(props.companySlug, props.data.id);
    const status = props.data.status;
    const onlyAmount = status === "NEW" || status === "ADMITTED" || status === "DECLINED" || status === "CANCELED";
    const notClosed = status === "NEW" || status === "ADMITTED" || status === "APPROVED";
    const expired = notClosed && ((_props_data_payAt = props.data.payAt) === null || _props_data_payAt === void 0 ? void 0 : _props_data_payAt.getTime()) < new Date().getTime();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
        className: classnames_default()((funding_request_entity_module_default()).funding_request_entity, props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                title: "Оплатить",
                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: classnames_default()(expired && (funding_request_entity_module_default()).red),
                    children: [
                        "до ",
                        (0,format_date/* formatDate */.p6)(props.data.payAt)
                    ]
                }),
                label: true,
                width: 80
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: props.href,
                    className: (funding_request_entity_module_default()).link,
                    children: [
                        "№",
                        props.data.number,
                        " ",
                        props.data.name
                    ]
                }),
                description: (_props_data_fund = props.data.fund) === null || _props_data_fund === void 0 ? void 0 : _props_data_fund.name,
                width: 220
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                title: "Запрошено",
                description: (0,format_number/* formatNumber */.u)(props.data.amount),
                label: true,
                right: true,
                width: 85
            }),
            !onlyAmount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        title: "Одобрено",
                        description: (0,format_number/* formatNumber */.u)(props.data.approvedAmount),
                        label: true,
                        right: true,
                        width: 85
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        title: "Выплачено",
                        description: (0,format_number/* formatNumber */.u)(props.data.paidAmount),
                        label: true,
                        right: true,
                        width: 85
                    }),
                    notClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                        title: "К выплате",
                        description: (0,format_number/* formatNumber */.u)(Number(props.data.approvedAmount) - Number(props.data.paidAmount)),
                        label: true,
                        right: true,
                        width: 85
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                right: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(status_status/* Status */.q, {
                    status: props.data.status,
                    type: "text",
                    row: "reverse"
                })
            })
        ]
    });
};
FundingRequestEntity.defaultProps = {};

// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/lib/pluralize.tsx
var pluralize = __webpack_require__(25819);
// EXTERNAL MODULE: ./src/shared/ui/list/list.tsx
var list = __webpack_require__(30954);
// EXTERNAL MODULE: ./src/shared/ui/entity-header/entity-header.tsx
var entity_header = __webpack_require__(97567);
// EXTERNAL MODULE: ./src/shared/ui/empty/empty.tsx
var empty = __webpack_require__(68264);
// EXTERNAL MODULE: ./src/modules/finances/widgets/funding-request-list/funding-request-list.module.scss
var funding_request_list_module = __webpack_require__(64568);
var funding_request_list_module_default = /*#__PURE__*/__webpack_require__.n(funding_request_list_module);
;// CONCATENATED MODULE: ./src/modules/finances/widgets/funding-request-list/funding-request-list.tsx







const FundingRequestList = (props)=>{
    var _props_data, _props_data1, _props_data2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        ...props,
        renderItem: (it)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(FundingRequestEntity, {
                data: it,
                companySlug: props.companySlug,
                href: _router/* default.company */.Z.company(props.companySlug).finances.fundingRequests.id(it.id).href
            }),
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity_header/* EntityHeader */.g, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (funding_request_list_module_default()).left,
                    children: [
                        "Всего",
                        " ",
                        (0,pluralize/* pluralize */._)((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.length, {
                            one: (it)=>"".concat(it, " заявка"),
                            few: (it)=>"".concat(it, " заявки"),
                            many: (it)=>"".concat(it, " заявок")
                        })
                    ]
                }),
                props.showTotal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (funding_request_list_module_default()).right,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (funding_request_list_module_default()).item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (funding_request_list_module_default()).label,
                                    children: "Запрошено:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (funding_request_list_module_default()).value,
                                    children: (0,format_number/* formatNumber */.u)((_props_data1 = props.data) === null || _props_data1 === void 0 ? void 0 : _props_data1.map((it)=>Number(it.amount)).reduce((a, b)=>a + b, 0))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (funding_request_list_module_default()).item,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (funding_request_list_module_default()).label,
                                    children: "Резерв:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (funding_request_list_module_default()).value,
                                    children: (0,format_number/* formatNumber */.u)((_props_data2 = props.data) === null || _props_data2 === void 0 ? void 0 : _props_data2.map((it)=>Number(it.approvedAmount) - Number(it.paidAmount)).reduce((a, b)=>a + b, 0))
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        empty: props.empty || /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
            title: "Нет заявок"
        })
    });
};
FundingRequestList.defaultProps = {};


/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83083);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10078);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const Sidebar = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const { groups , menu  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const propsMenu = props.menu.filter((it)=>it);
        if (!propsMenu.length) return {
            groups: null,
            menu: []
        };
        if ("menu" in propsMenu[0]) {
            const groups = propsMenu.map((it)=>({
                    ...it,
                    menu: it.menu.filter((it)=>it)
                }));
            const menu = groups.map((it)=>it.menu).flat();
            return {
                groups,
                menu
            };
        } else {
            return {
                groups: null,
                menu: propsMenu
            };
        }
    }, [
        props.menu
    ]);
    const checkActiveForDescktop = (menuItem)=>{
        if (router.asPath.startsWith(menuItem.additionalHref)) return true;
        switch(router.asPath){
            case menuItem.href:
                return true;
            case menuItem.additionalHref:
                return true;
            default:
                if (!menuItem.exact) return router.asPath.startsWith(menuItem.href);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const activeLink = menu.find((elem)=>{
            if (elem.exact) return router.asPath === elem.additionalHref;
            return router.asPath.startsWith(elem.href);
        });
        setActiveMenu(activeLink);
    }, [
        menu,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar), props.sticky && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar_adaptive),
                children: activeMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: props.mainHref,
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        activeMenu.label,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().spacer)
                        })
                    ]
                }) : menu.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().adaptive_item),
                        href: it.exact ? it.additionalHref : it.href,
                        children: it.label
                    }, it.href))
            }),
            groups === null || groups === void 0 ? void 0 : groups.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [
                        it.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().group_title),
                            children: it.title
                        }),
                        it.menu.map((it)=>{
                            const active = checkActiveForDescktop(it);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: it.href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: it.label
                            }, it.href);
                        })
                    ]
                }, key)),
            !groups && menu.map((it)=>{
                const active = checkActiveForDescktop(it);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: it.href,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                    children: it.label
                }, it.href);
            })
        ]
    });
};
Sidebar.defaultProps = {
    sticky: true
};


/***/ }),

/***/ 98730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _title_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30620);
/* harmony import */ var _title_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_title_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Title = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_title_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: props.children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_title_module_scss__WEBPACK_IMPORTED_MODULE_3___default().actions),
                children: props.actions
            })
        ]
    });
};
Title.defaultProps = {};


/***/ }),

/***/ 47656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WithSidebarContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57711);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11682);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const WithSidebarContainer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const hideOnMobile = router.asPath === props.mainHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
        fullWidth: props.fullWidth,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().with_sidebar_container), props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar),
                children: props.sidebar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), hideOnMobile && (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide_on_mobile)),
                children: props.children
            })
        ]
    });
};
WithSidebarContainer.defaultProps = {};


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMyPermissions; }
/* harmony export */ });
/* unused harmony export convertPermissions */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22823);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94840);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);


const convertPermissions = (roleType, permissions)=>{
    const set = new Set(permissions);
    const isOwner = roleType === shared_api__WEBPACK_IMPORTED_MODULE_1__/* .CompanyEmployeeRoleType.OWNER */ .Or.OWNER;
    return {
        finances: {
            budgets: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            plannings: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            fundingRequests: {
                create: true,
                readAll: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_READ_ALL */ .Mn.CLAIM_READ_ALL),
                acceptOrDecline: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */ .Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE),
                close: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE) || set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF),
                pay: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF)
            },
            funds: {
                withdraw: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_WITHDRAW */ .Mn.FUND_WITHDRAW),
                deposit: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_DEPOSIT */ .Mn.FUND_DEPOSIT),
                readProtected: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_SECURED_READ */ .Mn.FUND_SECURED_READ)
            }
        },
        company: {
            general: {
                update: isOwner,
                delete: isOwner
            },
            members: {
                invite: isOwner,
                update: isOwner,
                remove: isOwner
            },
            roles: {
                write: isOwner
            }
        }
    };
};
const useMyPermissions = (companySlug)=>{
    var _me_data;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const role = (_me_data = me.data) === null || _me_data === void 0 ? void 0 : _me_data.companyEmployeeRole;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!role ? null : convertPermissions(role.type, role.permissions), [
        role
    ]);
};


/***/ }),

/***/ 59906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ CompanyLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/auth/model/auth-guard.model.tsx
var auth_guard_model = __webpack_require__(95244);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/company/entities/company/company-expired/company-expired.module.scss
var company_expired_module = __webpack_require__(60978);
var company_expired_module_default = /*#__PURE__*/__webpack_require__.n(company_expired_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/company/company-expired/company-expired.tsx




const CompanyExpired = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((company_expired_module_default()).company_expired, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_expired_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Для этой компании закончился период доступа"
            })
        })
    });
};
CompanyExpired.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx + 13 modules
var header_dashboard = __webpack_require__(35622);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-navigation/header-navigation.tsx
var header_navigation = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-title/header-title.tsx
var header_title = __webpack_require__(35629);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/pages/[company]/_layout.tsx








const CompanyLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(companySlug);
    (0,auth_guard_model/* useGuardAuthedOnly */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_dashboard/* HeaderDashboard */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_navigation/* HeaderNavigation */.F, {
                menu: [
                    {
                        label: "Финансы",
                        href: _router/* default.company */.Z.company(companySlug).finances.href
                    },
                    // { label: "Департаменты", href: pages.company(companySlug).departments.href },
                    {
                        label: "Настройки",
                        href: _router/* default.company */.Z.company(companySlug).settings.href
                    }
                ],
                sticky: props.stickyNavigation
            }),
            company.data && !company.data.hasAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyExpired, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_title/* HeaderTitle */.G, {
                        fullWidth: true,
                        back: props.back,
                        actions: props.actions,
                        children: props.title
                    }),
                    props.children
                ]
            })
        ]
    });
};
CompanyLayout.defaultProps = {
    stickyNavigation: true
};


/***/ }),

/***/ 89220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ CompanyFinancesLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/modules/finances/_shared/model/has-deferred-incomes.ts

const useHasDeferredIncomes = (companySlugOrId)=>{
    var _deferredIncomeExists_data;
    const deferredIncomeExists = init/* api.deferredIncome.useDeferredIncomeExists */.h.deferredIncome.useDeferredIncomeExists(companySlugOrId);
    return (_deferredIncomeExists_data = deferredIncomeExists.data) === null || _deferredIncomeExists_data === void 0 ? void 0 : _deferredIncomeExists_data._exists;
};

// EXTERNAL MODULE: ./src/modules/layout/ui/with-sidebar-container/with-sidebar-container.tsx
var with_sidebar_container = __webpack_require__(47656);
// EXTERNAL MODULE: ./src/modules/layout/ui/sidebar/sidebar.tsx
var sidebar = __webpack_require__(6480);
// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/[company]/_layout.tsx + 1 modules
var _layout = __webpack_require__(59906);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/_layout.tsx








const CompanyFinancesLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(companySlug);
    const hasDeferred = useHasDeferredIncomes(companySlug);
    const mainHref = _router/* default.company */.Z.company(companySlug).finances.href;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_layout/* CompanyLayout */.q, {
        title: "Финансы",
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(with_sidebar_container/* WithSidebarContainer */.I, {
            mainHref: mainHref,
            fullWidth: props.fullWidth,
            sidebar: /*#__PURE__*/ (0,jsx_runtime.jsx)(sidebar/* Sidebar */.Y, {
                mainHref: mainHref,
                menu: [
                    {
                        menu: [
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Месячные бюджеты",
                                href: _router/* default.company */.Z.company(companySlug).finances.href,
                                exact: true,
                                additionalHref: _router/* default.company */.Z.company(companySlug).finances.plan.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Заявки на расход",
                                href: _router/* default.company */.Z.company(companySlug).finances.fundingRequests.href
                            },
                            !(permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Заявки на расход",
                                href: _router/* default.company */.Z.company(companySlug).finances.href,
                                exact: true,
                                additionalHref: _router/* default.company */.Z.company(companySlug).finances.fundingRequests.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Фонды и счета",
                                href: _router/* default.company */.Z.company(companySlug).finances.funds.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Движение средств",
                                href: _router/* default.company */.Z.company(companySlug).finances.reports.cashFlow.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.fundingRequests.pay) && {
                                label: "Выплаты",
                                href: _router/* default.company */.Z.company(companySlug).finances.payouts.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Займы",
                                href: _router/* default.company */.Z.company(companySlug).finances.loans.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && hasDeferred && {
                                label: "Отложенный доход",
                                href: _router/* default.company */.Z.company(companySlug).finances.deferredIncomes.href
                            },
                            (permissions === null || permissions === void 0 ? void 0 : permissions.finances.budgets.read) && {
                                label: "Обучение",
                                href: _router/* default.company */.Z.company(companySlug).finances.education.tableOfContent.href
                            },
                            {
                                label: "Настройки",
                                href: _router/* default.company */.Z.company(companySlug).finances.settings.href
                            }
                        ]
                    }
                ]
            }, companySlug),
            children: props.children
        })
    });
};


/***/ }),

/***/ 39772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var modules_finances__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18939);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pages_company_finances_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89220);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32636);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14183);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76780);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32825);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14080);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96916);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68264);
/* harmony import */ var _index_page_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45150);
/* harmony import */ var _index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9__);











const FinancesFundingRequestsPage = ()=>{
    var _fundGroupList_data;
    const companySlug = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query.company;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_4__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [my, setMy] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [fundId, setFundId] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const fundingRequestList = shared_api__WEBPACK_IMPORTED_MODULE_4__/* .api.fundingRequest.useFundingRequestList */ .h.fundingRequest.useFundingRequestList({
        companyIdOrSlug: companySlug,
        status,
        my,
        fundId,
        search
    });
    const fundGroupList = shared_api__WEBPACK_IMPORTED_MODULE_4__/* .api.fundGroup.useFundGroupList */ .h.fundGroup.useFundGroupList(companySlug);
    const fundList = shared_api__WEBPACK_IMPORTED_MODULE_4__/* .api.fund.useFundList */ .h.fund.useFundList(companySlug);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pages_company_finances_layout__WEBPACK_IMPORTED_MODULE_5__/* .CompanyFinancesLayout */ .G, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .D, {
                actions: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: pages_router__WEBPACK_IMPORTED_MODULE_7__/* ["default"].company */ .Z.company(companySlug).finances.fundingRequests.new.href,
                    legacyBehavior: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                        type: "secondary",
                        size: "small",
                        children: "Создать заявку"
                    })
                }),
                children: "Заявки на расходы"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default().filters),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default().line),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_10__/* .Switch */ .r, {
                                items: [
                                    {
                                        name: "Все",
                                        value: undefined
                                    },
                                    {
                                        name: "Ждут допуска к ФП",
                                        value: shared_api__WEBPACK_IMPORTED_MODULE_11__/* .FundingRequestSearchQueryStatus.NEW */ .hl.NEW
                                    },
                                    {
                                        name: "Открытые",
                                        value: shared_api__WEBPACK_IMPORTED_MODULE_11__/* .FundingRequestSearchQueryStatus.OPENED */ .hl.OPENED
                                    },
                                    {
                                        name: "К выплате",
                                        value: shared_api__WEBPACK_IMPORTED_MODULE_11__/* .FundingRequestSearchQueryStatus.FOR_PAYMENT */ .hl.FOR_PAYMENT
                                    },
                                    {
                                        name: "Закрытые",
                                        value: shared_api__WEBPACK_IMPORTED_MODULE_11__/* .FundingRequestSearchQueryStatus.CLOSED */ .hl.CLOSED
                                    }
                                ],
                                active: status,
                                onChange: setStatus
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_10__/* .Switch */ .r, {
                                items: [
                                    {
                                        name: "Все",
                                        value: undefined
                                    },
                                    {
                                        name: "Мои",
                                        value: true
                                    }
                                ],
                                active: my,
                                onChange: setMy
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_12__/* .Select */ .P, {
                                className: (_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default().funds),
                                value: fundId,
                                onChange: setFundId,
                                placeholder: "Все фонды",
                                allowEmpty: true,
                                options: (_fundGroupList_data = fundGroupList.data) === null || _fundGroupList_data === void 0 ? void 0 : _fundGroupList_data.map((group)=>{
                                    var _fundList_data;
                                    return {
                                        key: group.id,
                                        label: group.name,
                                        options: (_fundList_data = fundList.data) === null || _fundList_data === void 0 ? void 0 : _fundList_data.filter((it)=>it.fundGroupId === group.id).map((it)=>({
                                                value: it.id,
                                                label: it.name
                                            }))
                                    };
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default().line),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_13__/* .InputDebounced */ .Q, {
                            placeholder: "Поиск",
                            className: (_index_page_module_scss__WEBPACK_IMPORTED_MODULE_9___default().search),
                            value: search,
                            onChange: setSearch
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_finances__WEBPACK_IMPORTED_MODULE_14__/* .FundingRequestList */ .x, {
                companySlug: companySlug,
                ...fundingRequestList,
                showTotal: true,
                empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_15__/* .Empty */ .H, {
                    title: "Заявок на расходы нет",
                    description: "Тут будут отображаться заявки на расход",
                    actions: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: pages_router__WEBPACK_IMPORTED_MODULE_7__/* ["default"].company */ .Z.company(companySlug).finances.fundingRequests.new.href,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            type: "secondary",
                            size: "small",
                            children: "Создать заявку"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FinancesFundingRequestsPage);


/***/ }),

/***/ 14183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hl": function() { return /* binding */ FundingRequestSearchQueryStatus; }
/* harmony export */ });
/* unused harmony exports FundingRequestSearchQueryStatusFromJSON, FundingRequestSearchQueryStatusFromJSONTyped, FundingRequestSearchQueryStatusToJSON */
/* tslint:disable */ /* eslint-disable */ /**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 *
 * @export
 * @enum {string}
 */ var FundingRequestSearchQueryStatus;
(function(FundingRequestSearchQueryStatus) {
    FundingRequestSearchQueryStatus["DRAFT"] = "DRAFT";
    FundingRequestSearchQueryStatus["NEW"] = "NEW";
    FundingRequestSearchQueryStatus["OPENED"] = "OPENED";
    FundingRequestSearchQueryStatus["FOR_PAYMENT"] = "FOR_PAYMENT";
    FundingRequestSearchQueryStatus["CLOSED"] = "CLOSED";
})(FundingRequestSearchQueryStatus || (FundingRequestSearchQueryStatus = {}));
function FundingRequestSearchQueryStatusFromJSON(json) {
    return FundingRequestSearchQueryStatusFromJSONTyped(json, false);
}
function FundingRequestSearchQueryStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function FundingRequestSearchQueryStatusToJSON(value) {
    return value;
}


/***/ }),

/***/ 68984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bh": function() { return /* binding */ formatMonth; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

const formatDateTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace(".", "");
    }
    return result;
};
const formatTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    return new Date(value).toLocaleString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
        ...options
    });
};
const currentYear = new Date().getFullYear();
const formatDate = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace("марта", "мар").replace("февр.", "фев").replace(".", "");
    }
    return result;
};
const formatMonth = (month)=>{
    if (month === undefined || month === null) return;
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.local */ .ou.local(2000, Number(month)).setLocale("ru").toLocaleString({
        month: "long"
    });
};


/***/ }),

/***/ 9195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatNumber; }
/* harmony export */ });
const formatNumber = (value)=>{
    if (value === null || value === undefined) return undefined;
    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts[0];
};


/***/ }),

/***/ 25819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ pluralize; }
/* harmony export */ });
const pluralize = (num, options)=>{
    if (options["value" + num]) return options["value" + num](num);
    if (!num) return options.many(0);
    const _num = Math.abs(num);
    const res = _num % 100;
    if (11 <= res && res <= 20) return options.many(num);
    const rest = _num % 10;
    if (rest === 0) return options.many(num);
    if (rest === 1) return options.one(num);
    if (rest < 5) return options.few(num);
    return options.many(num);
};


/***/ }),

/***/ 97567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ EntityHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _entity_header_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3934);
/* harmony import */ var _entity_header_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_entity_header_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const EntityHeader = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_entity_header_module_scss__WEBPACK_IMPORTED_MODULE_3___default().entity_header), "entity-header", props.className),
        style: props.style,
        id: props.htmlId,
        children: props.children
    });
};
EntityHeader.defaultProps = {};


/***/ }),

/***/ 96916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ InputDebounced; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_ui_input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99088);
/* harmony import */ var use_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24697);




const nop = ()=>{};
const InputDebounced = (param)=>{
    let { wait =500 , value , onChange , ...props } = param;
    const [savedValue, setSavedValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value);
    const propsOnChange = (0,use_debounce__WEBPACK_IMPORTED_MODULE_2__/* .useDebouncedCallback */ .y1)(onChange || nop, wait);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setSavedValue(value);
    }, [
        value
    ]);
    const handleOnChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        setSavedValue(e.target.value);
        propsOnChange(e.target.value);
    }, [
        setSavedValue,
        propsOnChange
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui_input__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .I, {
        ...props,
        value: savedValue,
        onChange: handleOnChange
    });
};
InputDebounced.defaultProps = {};


/***/ }),

/***/ 32825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Switch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _switch_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6062);
/* harmony import */ var _switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_switch_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Switch = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["switch"]), props.size === "small" && (_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().small), props.size === "medium" && (_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().medium), props.size === "large" && (_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().large), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.items.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item), it.value === props.active && (_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().active), props.readOnly && (_switch_module_scss__WEBPACK_IMPORTED_MODULE_3___default().readonly)),
                style: it.width && {
                    width: it.width
                } || {},
                onClick: ()=>!props.readOnly && props.onChange(it.value),
                disabled: it.disabled,
                type: "button",
                children: it.name
            }, key))
    });
};
Switch.defaultProps = {
    size: "medium"
};


/***/ }),

/***/ 60978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_expired":"company-expired_company_expired__1K5vq","inner":"company-expired_inner__2NWWa"};

/***/ }),

/***/ 37316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__sMcVD","default":"status_default__8tp0T","text":"status_text__0kmIg","row":"status_row__PhfSF","reverse":"status_reverse__Ihqnn","circle":"status_circle__UvRTY","green":"status_green__MY_Wq","green_outline":"status_green_outline__K4dms","yellow":"status_yellow__yfnyN","yellow_outline":"status_yellow_outline__rQW3R","gray":"status_gray__3trrq","label":"status_label__7FOlW"};

/***/ }),

/***/ 1763:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"funding-request-entity_link__tU8s9","red":"funding-request-entity_red__2Lz6g"};

/***/ }),

/***/ 64568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"right":"funding-request-list_right__U5EHJ","item":"funding-request-list_item__5AmZJ","label":"funding-request-list_label__krZup"};

/***/ }),

/***/ 10078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__sYHpc","sticky":"sidebar_sticky__tqhuP","sidebar_adaptive":"sidebar_sidebar_adaptive__It1u0","adaptive_item":"sidebar_adaptive_item__UCFjh","title":"sidebar_title__41UVT","item":"sidebar_item__3MhXw","active":"sidebar_active__ezSut","group_title":"sidebar_group_title__gZU9o","spacer":"sidebar_spacer__WlMwR"};

/***/ }),

/***/ 30620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__UQ87O"};

/***/ }),

/***/ 11682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_sidebar_container":"with-sidebar-container_with_sidebar_container__nlbUn","sidebar":"with-sidebar-container_sidebar__s3m9i","main":"with-sidebar-container_main__UyQ8Z","hide_on_mobile":"with-sidebar-container_hide_on_mobile__F4a_D"};

/***/ }),

/***/ 45150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"index_page_header__MMaSk","filters":"index_page_filters__YthzE","line":"index_page_line__Zt0Gd","funds":"index_page_funds__c_Ir8","search":"index_page_search___7_DY"};

/***/ }),

/***/ 3934:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_header":"entity-header_entity_header__Zy_pb"};

/***/ }),

/***/ 6062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__JqwRc","small":"switch_small__jlM7r","large":"switch_large__zfQe2","item":"switch_item__kyQ5t","active":"switch_active__dmKxZ"};

/***/ }),

/***/ 24697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y1": function() { return /* binding */ c; }
/* harmony export */ });
/* unused harmony exports useDebounce, useThrottledCallback */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function c(u,e,c){var i=this,a=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),l=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]),m=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(),d=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(u),p=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!0);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){d.current=u},[u]);var g=!e&&0!==e&&"undefined"!=typeof window;if("function"!=typeof u)throw new TypeError("Expected a function");e=+e||0;var w=!!(c=c||{}).leading,s=!("trailing"in c)||!!c.trailing,x="maxWait"in c,y=x?Math.max(+c.maxWait||0,e):null;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function(){return p.current=!0,function(){p.current=!1}},[]);var h=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function(){var r=function(r){var n=l.current,t=m.current;return l.current=m.current=null,o.current=r,v.current=d.current.apply(t,n)},n=function(r,n){g&&cancelAnimationFrame(f.current),f.current=g?requestAnimationFrame(r):setTimeout(r,n)},t=function(r){if(!p.current)return!1;var n=r-a.current;return!a.current||n>=e||n<0||x&&r-o.current>=y},u=function(n){return f.current=null,s&&l.current?r(n):(l.current=m.current=null,v.current)},c=function r(){var c=Date.now();if(t(c))return u(c);if(p.current){var i=e-(c-a.current),f=x?Math.min(i,y-(c-o.current)):i;n(r,f)}},h=function(){var u=Date.now(),d=t(u);if(l.current=[].slice.call(arguments),m.current=i,a.current=u,d){if(!f.current&&p.current)return o.current=a.current,n(c,e),w?r(a.current):v.current;if(x)return n(c,e),r(a.current)}return f.current||n(c,e),v.current};return h.cancel=function(){f.current&&(g?cancelAnimationFrame(f.current):clearTimeout(f.current)),o.current=0,l.current=a.current=m.current=f.current=null},h.isPending=function(){return!!f.current},h.flush=function(){return f.current?u(Date.now()):v.current},h},[w,x,e,y,s,g]);return h}function i(r,n){return r===n}function a(r){return"function"==typeof r?function(){return r}:r}function o(n,t,o){var f,l,m=o&&o.equalityFn||i,v=(f=e(a(n)),l=f[1],[f[0],u(function(r){return l(a(r))},[])]),d=v[0],p=v[1],g=c(u(function(r){return p(r)},[p]),t,o),w=r(n);return m(w.current,n)||(g(n),w.current=n),[d,g]}function f(r,n,t){var u=void 0===t?{}:t,e=u.leading,i=u.trailing;return c(r,n,{maxWait:n,leading:void 0===e||e,trailing:void 0===i||i})}
//# sourceMappingURL=index.module.js.map


/***/ })

}]);